/* API endpoints ( All API endpoints to be defined here ) */
export const apiRoutes = {
    auth: {
        login: '/auth/login',
        googleLogin: '/auth/sso',
    },
    chat: {
        leaveConversation: "/leave_room_instantly",
        join_Room:'/admin_join_room'

    },
}